import { Emitter } from '@tencent/ark-utils/lib/event';
var IConnectState;
(function (IConnectState) {
    IConnectState["ON"] = "ON";
    IConnectState["OFF"] = "OFF";
})(IConnectState || (IConnectState = {}));
var MessageBroadcastChannel = /** @class */ (function () {
    function MessageBroadcastChannel(name, messageCheckFn) {
        this.emitter = new Emitter();
        this.listenersArray = [];
        if (window.BroadcastChannel) {
            this.channel = new window.BroadcastChannel(name);
        }
        this.messageCheckFn = messageCheckFn;
    }
    MessageBroadcastChannel.prototype.connect = function () {
        var _this = this;
        if (this.connectState === IConnectState.ON) {
            return;
        }
        this.connectState = IConnectState.ON;
        this.emitter.event(function (message) {
            _this.listenersArray.forEach(function (listener) {
                if (typeof listener === 'function') {
                    listener(message);
                }
            });
        });
        this.channel.onmessage = this.messageCallback.bind(this);
    };
    MessageBroadcastChannel.prototype.send = function (message) {
        var _a;
        (_a = this.channel) === null || _a === void 0 ? void 0 : _a.postMessage(message);
    };
    MessageBroadcastChannel.prototype.receive = function (listener) {
        if (this.listenersArray.includes(listener)) {
            return;
        }
        this.listenersArray.push(listener);
    };
    MessageBroadcastChannel.prototype.dispose = function () {
        var _a;
        (_a = this.channel) === null || _a === void 0 ? void 0 : _a.close();
    };
    MessageBroadcastChannel.prototype.messageCallback = function (e) {
        var result = true;
        if (this.messageCheckFn) {
            result = this.messageCheckFn(e);
        }
        if (result) {
            this.emitter.fire(e);
        }
    };
    return MessageBroadcastChannel;
}());
export { MessageBroadcastChannel };
